import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { hexToRgba } from "../../../../themes/hex-to-rgba";

const UserMenuSectionDefaultBox = styled.div`
    /* .user-menu-box */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    color: ${({theme}) => theme.colors.text};
    background: ${({theme}) => theme.colors.background};
    border-radius: 5px;
`;

/* 777 */
const UserMenuSectionCasino777Box = styled(UserMenuSectionDefaultBox)`
    /* .user-menu-box */
    position: relative;
    margin-top: 50px;
    padding-top: 25px;
    background: linear-gradient(-45deg, rgba(252,246,213,0.8) 33.33%, rgba(25,50,47,0.1) 33.33%, rgba(25,50,47,0.2) 50%, rgba(252,246,213,0.8) 50%, rgba(252,246,213,0.8) 83.33%, rgba(25,50,47,0.1) 83.33%, rgba(25,50,47,0.1) 100%);
    background-size: 4px 4px;
    box-shadow: 2px 3px 1rem rgba(25,50,48,0.2);

    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 50px;
        height: 50px;
        background: ${({theme}) => theme.colors.background};
        border-top: 1px solid ${({theme}) => hexToRgba(theme.colors.textMiddleDark, 0.5) };
        border-left: 1px solid ${({theme}) => hexToRgba(theme.colors.textMiddleDark, 0.5) };
        box-shadow: 0.5rem 0.5rem 1rem rgba(25,50,47,0.2);
        transform: rotate(45deg) translate(calc(-50% - 10px));

        ${CssRule.For.RTL.build()} &{
            left: auto;
            right: 50%;
        }
    }
`;

/* 888 */
/* delaware */
/* bally's dover */
/* harrington */
const UserMenuSectionCasino888Box = styled(UserMenuSectionDefaultBox)`
    /* .user-menu-box */
    margin-top: 4rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {  
      margin-top: 0;
    }
`;

const UserMenuSectionCasinoSIBox = styled(UserMenuSectionDefaultBox)`
    margin-top: 4rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {  
        margin-top: 1rem;
    }
`;

export const UserMenuSectionBox = styledByTheme(UserMenuSectionDefaultBox)
    .forCasino777(UserMenuSectionCasino777Box)
    .forCasino888(UserMenuSectionCasino888Box)
    .forDelawarePark(UserMenuSectionCasino888Box)
    .forBallysDover(UserMenuSectionCasino888Box)
    .forHarrington(UserMenuSectionCasino888Box)
    .forSI(UserMenuSectionCasinoSIBox)
    .apply();
